import React from "react"
import styled from "styled-components"
import CurrencyLogo from "./CurrencyLogo"
import OracleInputSymbol from "./OracleInputSymbol"
import OracleEmptyInputSymbol from "./OracleEmptyInputSymbol"

import { IMAGES_FOLDER } from "../config"

const OracleInputCurrency = styled.div`
	display: flex;
	align-self: center;
	justify-content: center;
	text-align: center;
`

const _OracleInputCurrencyWrapper = styled.div`
	box-shadow: ${({ theme }) => theme.currencyShadow};
    color: ${({ theme, isValidCurrency }) => isValidCurrency ? theme.currencyTextColor : theme.emptyCurrencyTextColor};
    background-color: ${({ theme, isValidCurrency }) => isValidCurrency ? theme.currencyBackgroundColor : theme.emptyCurrencyBackgroundColor};
    cursor: pointer;
    pointer-events: auto;
    src: $(props => props.src);
	display: flex;
	flex-direction: row;
	align-self: center;
    border-radius: 0.7em;
    margin: 0.3em;
    padding: 0.5em;
`;

function OracleInputCurrencyWrapper(props) {
	return(
		<_OracleInputCurrencyWrapper onClick={props.onClick} isValidCurrency={props.currency != undefined}>
			{
				props.currency ?
				<OracleInputCurrency>
					<CurrencyLogo src={require("../" + IMAGES_FOLDER + props.currency["symbol"].toLowerCase() + "-logo.png")}/>
					<OracleInputSymbol>{props.currency["symbol"]}</OracleInputSymbol>
				</OracleInputCurrency>
				: <OracleEmptyInputSymbol>{props.message}</OracleEmptyInputSymbol>
			}
		</_OracleInputCurrencyWrapper>
	)
}

export default OracleInputCurrencyWrapper;

